var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackage01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Package_-_01",
    width: 88,
    height: 88,
    "data-name": "Package - 01",
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#11763b}.cls-4{fill:#fff}.cls-6{fill:#d7d7d7}\n        "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_907",
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#f0f0f0",
    "data-name": "Ellipse 907"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3906",
    "data-name": "Group 3906",
    transform: "translate(12.862 26.116)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3898",
    "data-name": "Group 3898"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6421",
    d: "M422.5 586.957h-16.453l1.811-10.243h12.83z",
    className: "cls-2",
    "data-name": "Path 6421",
    transform: "translate(-384.389 -538.657)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6422",
    d: "M414.257 651.208H397.19a.989.989 0 0 0-1.056.906.989.989 0 0 0 1.056.905h17.067a.989.989 0 0 0 1.056-.905.989.989 0 0 0-1.056-.906z",
    className: "cls-2",
    "data-name": "Path 6422",
    transform: "translate(-375.84 -602.908)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2003",
    width: 59.767,
    height: 41.656,
    fill: "#22b560",
    "data-name": "Rectangle 2003",
    rx: 3,
    transform: "rotate(-180 29.884 20.828)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2004",
    width: 54.334,
    height: 31.733,
    className: "cls-4",
    "data-name": "Rectangle 2004",
    rx: 2,
    transform: "rotate(-180 28.525 17.224)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3902",
    "data-name": "Group 3902",
    transform: "translate(51.225 26.602)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2005",
    width: 16.552,
    height: 28.375,
    fill: "#ffc001",
    "data-name": "Rectangle 2005",
    rx: 2,
    transform: "rotate(180 8.276 14.188)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2006",
    width: 13.287,
    height: 22.563,
    className: "cls-4",
    "data-name": "Rectangle 2006",
    rx: 1,
    transform: "rotate(180 7.46 12.196)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3901",
    "data-name": "Group 3901",
    transform: "translate(2.736 5.718)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2007",
    width: 11,
    height: 2.2,
    className: "cls-6",
    "data-name": "Rectangle 2007",
    rx: 1.1,
    transform: "translate(0 8.774)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2008",
    width: 11,
    height: 2.2,
    className: "cls-6",
    "data-name": "Rectangle 2008",
    rx: 1.1,
    transform: "translate(0 11.799)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2009",
    width: 11,
    height: 2.2,
    className: "cls-6",
    "data-name": "Rectangle 2009",
    rx: 1.1,
    transform: "translate(0 14.824)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3900",
    "data-name": "Group 3900",
    transform: "translate(.922)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_908",
    cx: 0.624,
    cy: 0.624,
    r: 0.624,
    className: "cls-6",
    "data-name": "Ellipse 908",
    transform: "translate(7.203 .185)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3899",
    "data-name": "Group 3899"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6423",
    d: "M652.679 539.287h-4.99l2.5-4.3z",
    className: "cls-6",
    "data-name": "Path 6423",
    transform: "translate(-647.688 -534.988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6424",
    d: "M672.567 546.54h-4.918l2.46-3.141z",
    className: "cls-6",
    "data-name": "Path 6424",
    transform: "translate(-664.904 -542.241)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6425",
    d: "M692.826 552.772h-3.512l1.757-2.148z",
    className: "cls-6",
    "data-name": "Path 6425",
    transform: "translate(-683.59 -548.473)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3905",
    "data-name": "Group 3905",
    transform: "translate(9.258 6.992)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3903",
    "data-name": "Group 3903",
    transform: "translate(0 13.527)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2010",
    width: 41.25,
    height: 2.75,
    className: "cls-6",
    "data-name": "Rectangle 2010",
    rx: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2011",
    width: 41.25,
    height: 2.75,
    className: "cls-6",
    "data-name": "Rectangle 2011",
    rx: 1.375,
    transform: "translate(0 3.847)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2012",
    width: 41.25,
    height: 2.75,
    className: "cls-6",
    "data-name": "Rectangle 2012",
    rx: 1.375,
    transform: "translate(0 7.69)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_909",
    cx: 1.095,
    cy: 1.095,
    r: 1.095,
    className: "cls-6",
    "data-name": "Ellipse 909",
    transform: "translate(25.162 .324)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3904",
    "data-name": "Group 3904",
    transform: "translate(12.531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6426",
    d: "M415.758 368.323h-8.751l4.378-7.535z",
    className: "cls-6",
    "data-name": "Path 6426",
    transform: "translate(-407.007 -360.785)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6427",
    d: "M450.635 381.042h-8.625l4.315-5.508z",
    className: "cls-6",
    "data-name": "Path 6427",
    transform: "translate(-437.197 -373.503)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6428",
    d: "M486.161 391.971h-6.159l3.081-3.766z",
    className: "cls-6",
    "data-name": "Path 6428",
    transform: "translate(-469.965 -384.432)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage01);
export default __webpack_public_path__ + "static/media/package-01.8ab6cc91d21c14d1c23145339b61e65c.svg";
export { ForwardRef as ReactComponent };